
import React, { useState, useEffect } from "react";
import UserSidebar from "../../Component/UserSidebar";
import { Link, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as userAction from "../../actions/userActions";
import * as settingActions from "../../actions/settingActions";
import * as baseActions from "../../actions/baseActions";
import { useForm } from "react-hook-form";
import Button from "../../Component/Button";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Row, Col, Form } from "react-bootstrap";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
}

const Refer = (props) => {
  const { title, actions, updateProfileData, userInfo, setting, isLoad } = props;
  const history = useNavigate();
  const { register, formState: { errors }, handleSubmit, setValue } = useForm();
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  console.log("", email);

  const savedRole = localStorage.getItem("userRole");

  const replaceSenderName = (text, senderName) => {
    if (!text) return "";
    return text.replaceAll("[SENDER_NAME]", senderName || "User");
  };

  // 1️⃣ Resolve role from redux OR localStorage
  const resolvedRole =
    userInfo?.role_id ||
    savedRole ||
    null;

  // 2️⃣ Normalize role naming
  const roleId = resolvedRole === "Mentees" ? "Mentee" : resolvedRole;

  useEffect(() => {
    document.title = title;
    actions.getUserProfile(userInfo.id);
    // Register description field with validation
    register('description', {
      required: {
        value: true,
        message: "Please enter your description"
      }
    });
  }, [title, actions, userInfo, register]);

  const [inviteTitle, setInviteTitle] = useState("")

  const formatEmailForCKEditor = (text) => {
    if (!text) return "";
    const paragraphs = text.split(/\n\s*\n/);
    return paragraphs.map((para) => `<p>${para.replaceAll("\n", '<br>')}</p>`).join('');
  };

  useEffect(() => {
    if (setting) {
      const senderName =
        updateProfileData?.full_name ||
        `${updateProfileData?.first_name || ""} ${updateProfileData?.last_name || ""}`.trim() || "User";

      if (userInfo.role_id == 'Mentees') {
        setSubject(setting?.mentee_invite_title || "");

        const content = replaceSenderName(setting?.mentee_invite, senderName);
        const formattedContent = formatEmailForCKEditor(content);

        setInviteTitle(formattedContent);
        setValue("description", formattedContent);

      } else {
        setSubject(setting?.mentor_invite_title || "");

        const content = replaceSenderName(setting?.mentor_invite, senderName);
        const formattedContent = formatEmailForCKEditor(content);

        setInviteTitle(formattedContent);
        setValue("description", formattedContent);
      }
    }
  }, [setting, userInfo, updateProfileData, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const result = await actions.Refer(data, updateProfileData.id);
      if (result?.status === 200) {
        setPopupMessage(result?.message || "Referral sent successfully!");
        setShowPopup(true);
      } else {
        setPopupMessage(result?.message || "Failed to send referral. Please try again.");
        setShowPopup(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleReferPopupClose = () => {
    setShowPopup(false);
    // reset form
    setValue("email", "");
    setEmail("");
    // redirect after user clicks OK
    history("/refer");
  };

  useEffect(() => {
    if (subject) {
      setValue("subject", subject); // sync form value
    }
  }, [subject]);

  return (

    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>

          {roleId && <h1 className="dash_heading mb-3">Invite a {roleId}</h1>}

          <div className="box shadow bg-white p-4">

            <div className="studentformdashboard">

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Control
                  type="hidden"
                  name="id"
                  defaultValue={updateProfileData.id}
                  {...register("id")}
                />
                <Row>

                  <Col md={12}>
                    <Row className="align-items-center">
                      <Col sm={12}>
                        <Row>
                          <Col md={12} sm={12} className="mb-3">
                            <Form.Group controlId="formBasicEmail">
                              <Form.Control
                                type="text"
                                placeholder="Email Address*"
                                className={errors?.email ? "formError" : ""}
                                name="email"
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                }}
                                aria-invalid={errors?.email ? "true" : "false"}
                                {...register("email", {
                                  required: true,
                                  pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  },
                                  maxLength: 50,
                                })}
                                style={{ color: '#495057' }}
                              />
                              {errors?.email &&
                                errors?.email.type === "required" && (
                                  <span role="alert">
                                    Please enter your email address
                                  </span>
                                )}
                              {errors?.email &&
                                errors?.email.type === "pattern" && (
                                  <span role="alert">Invalid email address</span>
                                )}
                              {errors?.email &&
                                errors?.email.type === "maxLength" && (
                                  <span role="alert">
                                    Your email should contain max 50 characters
                                  </span>
                                )}
                            </Form.Group>
                          </Col>
                          <Col md={12} sm={12} className="mb-3">
                            <Form.Group controlId="formBasicSubject">
                              <Form.Control
                                type="text"
                                placeholder="Enter Subject Line*"
                                className={errors?.subject ? "formError" : ""}
                                aria-invalid={errors?.subject ? "true" : "false"}
                                defaultValue={subject}
                                name="subject"
                                value={subject || ""}
                                onChange={(e) => {
                                  setSubject(e.target.value);
                                  setValue("subject", e.target.value, { shouldValidate: true });
                                }}
                                {...register("subject", {
                                  required: true,
                                  validate: {
                                    whiteSpace: (value) =>
                                      value.trim() ? true : "White spaces not allowed.",
                                  },
                                  maxLength: 250,
                                })}
                                style={{ color: '#495057' }}
                              />
                              {errors?.subject &&
                                errors?.subject?.type === "required" && (
                                  <span role="alert">
                                    Please enter your subject
                                  </span>
                                )}
                              {errors?.subject &&
                                errors?.subject.type === "whiteSpace" && (
                                  <span role="alert">
                                    Whitespace not allowed
                                  </span>
                                )}
                              {errors?.subject &&
                                errors?.subject.type === "maxLength" && (
                                  <span role="alert">
                                    Your subject should contain max 250 characters
                                  </span>
                                )}
                            </Form.Group>
                          </Col>
                          <Col sm={12} className="mb-3">
                            <div className="form-group">
                              <CKEditor
                                editor={ClassicEditor}
                                data={inviteTitle || ""}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setValue("description", data);
                                }}
                                onReady={(editor) => {
                                  // Set initial data if available
                                  if (inviteTitle) {
                                    editor.setData(inviteTitle);
                                    setValue("description", inviteTitle);
                                  }
                                }}
                              />
                              {errors?.description && errors?.description.type === "required" && (
                                <label className="invalid-feedback text-left d-block" htmlFor="description">
                                  Please enter your description
                                </label>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <div className="form-group mt-3">
                      <Button
                        title={loading ? "Submitting..." : "Submit"}
                        className={"btn w-10 loginsubmit"}
                        disabled={loading}
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <button type="button" className="sidebar_overlay" onClick={SidebarRemoveClass}></button>

      <PopupModalWithOk
        show={showPopup}
        onHide={handleReferPopupClose}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </div>
  );
};

Refer.propTypes = {
  actions: PropTypes.shape({
    getUserProfile: PropTypes.func,
    Refer: PropTypes.func,
  }).isRequired,
  title: PropTypes.string.isRequired,
  updateProfileData: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    full_name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    role_id: PropTypes.string,
  }).isRequired,
  setting: PropTypes.shape({
    mentee_invite_title: PropTypes.string,
    mentee_invite: PropTypes.string,
    mentor_invite_title: PropTypes.string,
    mentor_invite: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    isData: state.isData,
    updateProfileData: state.updateProfileData,
    isLoad: state.isLoad,
    userInfo: state.userInfo,
    isAuth: state.isAuth,
    setting: state.setting
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userAction, ...baseActions, ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Refer);
